"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftRequestPublicAbbrDto = instanceOfShiftRequestPublicAbbrDto;
exports.ShiftRequestPublicAbbrDtoFromJSON = ShiftRequestPublicAbbrDtoFromJSON;
exports.ShiftRequestPublicAbbrDtoFromJSONTyped = ShiftRequestPublicAbbrDtoFromJSONTyped;
exports.ShiftRequestPublicAbbrDtoToJSON = ShiftRequestPublicAbbrDtoToJSON;
exports.ShiftRequestPublicAbbrDtoToJSONTyped = ShiftRequestPublicAbbrDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
const RequestedBy_1 = require("./RequestedBy");
const NurseShiftCancellationDto_1 = require("./NurseShiftCancellationDto");
/**
 * Check if a given object implements the ShiftRequestPublicAbbrDto interface.
 */
function instanceOfShiftRequestPublicAbbrDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined)
        return false;
    if (!('requestStatus' in value) || value['requestStatus'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('hasLoggedTime' in value) || value['hasLoggedTime'] === undefined)
        return false;
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    if (!('orientationId' in value) || value['orientationId'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('specialty' in value) || value['specialty'] === undefined)
        return false;
    if (!('cancellation' in value) || value['cancellation'] === undefined)
        return false;
    return true;
}
function ShiftRequestPublicAbbrDtoFromJSON(json) {
    return ShiftRequestPublicAbbrDtoFromJSONTyped(json, false);
}
function ShiftRequestPublicAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'requestedBy': (0, RequestedBy_1.RequestedByFromJSON)(json['requestedBy']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
        'facilityId': json['facilityId'],
        'hasLoggedTime': json['hasLoggedTime'],
        'didNotWork': json['didNotWork'],
        'orientationId': json['orientationId'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'cancellation': (0, NurseShiftCancellationDto_1.NurseShiftCancellationDtoFromJSON)(json['cancellation']),
        'submittedTimeAt': json['submittedTimeAt'] == null ? undefined : (new Date(json['submittedTimeAt'])),
    };
}
function ShiftRequestPublicAbbrDtoToJSON(json) {
    return ShiftRequestPublicAbbrDtoToJSONTyped(json, false);
}
function ShiftRequestPublicAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'requestedBy': (0, RequestedBy_1.RequestedByToJSON)(value['requestedBy']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
        'facilityId': value['facilityId'],
        'hasLoggedTime': value['hasLoggedTime'],
        'didNotWork': value['didNotWork'],
        'orientationId': value['orientationId'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'cancellation': (0, NurseShiftCancellationDto_1.NurseShiftCancellationDtoToJSON)(value['cancellation']),
        'submittedTimeAt': value['submittedTimeAt'] == null ? undefined : ((value['submittedTimeAt']).toISOString()),
    };
}
//# sourceMappingURL=ShiftRequestPublicAbbrDto.js.map